/*
 * By defalt SlideOut displays over other content, but adding the class "slide-adjust"
 * to an ancestor element of slide-in will cause it to adjut its width and remain
 * un-obscured. The Styling for the "slide-adjust" class is in slide_in.css.
 *
 * The content of the SlideIn is set with a "src" attribute.
 */

export class SlideIn extends HTMLElement {
  static get observedAttributes() { return ['src', 'state']; }
  constructor() {
    super();
    let shadow = this.attachShadow({mode: 'open'});

    let content = this._content = document.createElement('iframe');
    content.id = 'content';
    content.setAttribute('scrolling','no');
    let container = this._container = document.createElement('div');
    container.id = 'container';
    container.append(content);

    let tab = this._tab = document.createElement('button');
    tab.id = 'tab';
    tab.innerHTML = `<slot name="open"></slot><slot name=close></slot>`;

    let style = this._style = document.createElement('style');
    style.textContent = `
:host{
  position: fixed;
  pointer-events: none;
  width: calc(var(--slide-out-width) + var(--slide-tab-width));
  height: calc(100vh - 52px);
  top: 52px;
  z-index: 100;
  display: grid;
  grid-template-rows: 8em 3em 1fr;
  grid-template-columns: var(--slide-tab-width) 1fr;
  grid-template-areas:
    ". content"
    "tab content"
    ". content";
}

#tab, #container {
  pointer-events: auto;
  opacity: 0;
  animation: 0.5s 0.5s forwards fadein;
}

@keyframes fadein {
  from {opacity: 0;}
  to {opacity: 1;}
}

:host([state=open]) {
  right: calc(var(--slide-out-width) * -1);
  animation: 0.5s forwards slidein;
}

:host(:not([state=open])) {
  right: calc(var(--slide-out-width) * -1);
  animation: 0.5s forwards slideout;
}


@keyframes slidein {
  from {right: calc(var(--slide-out-width) * -1);}
  to {right: 0;}
}

@keyframes slideout {
  from {right: 0;}
  to {right: calc(var(--slide-out-width) * -1);}
}

@-moz-document url-prefix() { /*Hide slide-out scrollbar in Firefox*/
  :host{
    scrollbar-width: none;
  }
}

#tab iframe::-webkit-scrollbar {
  display: none;
}

#tab {
  cursor: pointer;
  grid-area: tab;
  background-color: #eee;
  border: none;
  border-radius: 5px 0 0 5px;
  padding: 0 1em;
  box-shadow: 0px 1px 4px 0px #00000040;
}

#tab:focus {
  //border: none;
  outline:none;
}

:host([state=open]) slot[name=open],
:host(:not([state=open])) slot[name=close] {
  display: none;
}

:host([state=open]) slot[name=close],
:host(:not([state=open])) slot[name=open] {
  display: auto;
}

#container {
  grid-area: content;
  width: 100%;
  border: none;
  background-color: white;
  border-left: 1px solid #aaa;
  overflow: auto;
}

/*Hide slide-out scrollbar*/

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
}
::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.125);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

#container::-webkit-scrollbar {
  // opacity:0;
  // width: 0;
}

@-moz-document url-prefix() { /*Hide slide-out scrollbar in Firefox*/
  // #container {
  //   scrollbar-width: none;
  // }
}

#content {
  width: 100%;
  border: none;
}

    `;

    shadow.append(style,container,tab);
  }

  connectedCallback(){
    this._tab.onclick = this.toggleState.bind(this);
    this._adjust = this.closest('.slide-adjust');
  }

  attributeChangedCallback(name, oldValue, newValue) {
     switch (name) {
      case 'src':
        if(newValue!==this._content.src) this.src = newValue;
        break;
      case 'state':
        if(newValue!==this._state) this.state = newValue;
        break;
    }
  }

  get state(){
    return this._state;
  }

  set state(state){
    this._state = state;
    this.setAttribute('state', state);
  }

  toggleState(){
    //Sets the height of the frame to be slightly larger than the height of the content to avoid an issue with scrollbar styling. Origianilly in the connected callback. Moved here because it was firing before the content was fully loaded.
    if(this._content.style.height !== this._content.contentWindow.document.body.scrollHeight){
      this._content.style.height = 50 + this._content.contentWindow.document.body.scrollHeight+"px";
    }
    let adj = this._adjust.classList;
    switch (this._state) {
      case 'open':
        this.state = 'closed';
        if(adj && adj.contains('open')) adj.remove('open');
        break;
      default:
        this.state = 'open';
        if(adj && !adj.contains('open')) adj.add('open');
    }
    this.open = !this.open;
  }

  get src() {
    return this._content.src;
  }

  set src(src){
    if(src && this._content){
      this._content.src = src;
    }
  }
}

customElements.define('slide-in', SlideIn);
